import { createAction, props } from '@ngrx/store';

import {
  OccupationProfileModel,
  OccupationQuickMatchModel
} from '@cpd-app/core-module/models';

export const setOccupationProfile = createAction(
  '[Occupations] Set Occupation Profile',
  props<{ occupationProfileModel: OccupationProfileModel }>()
);

export const removeOccupationProfile = createAction(
  '[Occupations] Remove Occupation Profile'
);

export const requestOccupationsByDemandList = createAction(
  '[Occupations] Request Occupations By Demand List'
);

export const receivedOccupationsByDemandList = createAction(
  '[Occupations] Received Occupations By Demand List',
  props<{ entities: OccupationQuickMatchModel[] }>()
);

export const requestMilitaryFriendlyOccupationsList = createAction(
  '[Occupations] Request Military Friendly Occupations List'
);

export const receivedMilitaryFriendlyOccupationsList = createAction(
  '[Occupations] Received Military Friendly Occupations List',
  props<{ entities: OccupationQuickMatchModel[] }>()
);
